export const notifications = {
  notifications: {
    prompt: {
      title: "Receive important notifications",
      description: "Enable notifications to receive alerts about special promotions, game results and news.",
      error: "An error occurred while enabling notifications",
      later: "Later",
      enable: "Enable notifications",
      activating: "Activating...",
    },
  },
};
